import { BaseQueryFn } from '@reduxjs/toolkit/query/react';
import axiosInstance from '../../helpers/axiosInstanceHelper';

// Хариу өгөгдлийн төрөл
type QueryReturnValue<T> = {
  data?: T;
  error?: {
    status?: number;
    data?: any;
  };
};

// axiosBaseQuery-ийг тодорхойлох
const axiosBaseQuery: BaseQueryFn<string | { url: string; method?: string; body?: any; } | { url: string; method?: string; body?: any; header?: any}, unknown, QueryReturnValue<any>> = async (args) => {
  // console.log(args);
  
  try {
    const resp= await axiosInstance(args);
    const data= {data: resp?.data}
    if(resp?.pagination) data['pagination']=resp.pagination;
    return data;
  } catch (error: any) {
    return {
      error: {
        status: error.response?.status || false,
        data: error.response?.data || error.response?.error || error,
      },
    };
  }
};

export default axiosBaseQuery;
